import React from 'react';
import { BENTO_ITEMS } from '../../data/ecoContent';
import { DoubleBezelCard } from '../common/DoubleBezelCard';

export const BentoBiosphereOS: React.FC = () => {
  return (
    <section
      id="architecture"
      className="relative py-24 sm:py-32 px-4 sm:px-6 z-10 border-t border-carbon-900/10 bg-alabaster-200/40"
    >
      <div className="max-w-7xl mx-auto space-y-12">
        {/* Section Header */}
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4">
          <div>
            <div className="flex items-center gap-2 text-xs font-mono text-chlorophyll-deep tracking-widest uppercase mb-2">
              <span className="w-2 h-2 bg-chlorophyll inline-block" />
              <span>04 // SYSTEM ARCHITECTURE</span>
            </div>
            <h2 className="font-serif font-black text-4xl sm:text-5xl text-carbon-900 tracking-tight">
              Biosphere Operating System.
            </h2>
          </div>
          <p className="font-mono text-xs text-carbon-900/60 max-w-sm sm:text-right">
            CONTINUOUS MULTI-MODAL SENSING // PHYSICAL GROUND TRUTH
          </p>
        </div>

        {/* 12-Column Architectural Catalog Grid */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-5 sm:gap-6">
          {BENTO_ITEMS.map((item) => (
            <div key={item.id} className={item.colSpan}>
              <DoubleBezelCard
                enableTilt={true}
                glowColor={item.glowColor || 'emerald'}
                className="p-6 sm:p-8 flex flex-col justify-between h-full min-h-[290px]"
              >
                <div>
                  {/* Metadata Row */}
                  <div className="flex items-center justify-between pb-4 mb-4 border-b border-carbon-900/10 text-xs font-mono">
                    <span className="text-carbon-900/50 tracking-wider text-[10px] uppercase">
                      {item.tag}
                    </span>
                    {item.badge && (
                      <span className="px-2.5 py-0.5 rounded-none bg-chlorophyll/10 border border-chlorophyll/30 text-chlorophyll-deep text-[10px] font-bold tracking-widest font-mono">
                        {item.badge}
                      </span>
                    )}
                  </div>

                  <h3 className="font-serif font-bold text-xl sm:text-2xl text-carbon-900 mb-3">
                    {item.title}
                  </h3>
                  <p className="text-xs sm:text-sm text-carbon-900/70 leading-relaxed mb-6">
                    {item.description}
                  </p>
                </div>

                {/* Bottom Spec and Metric */}
                <div className="pt-4 border-t border-carbon-900/10 flex items-center justify-between font-mono">
                  <div className="text-[10px] text-carbon-900/40 truncate pr-2">
                    {item.technicalSpec}
                  </div>
                  <div className="text-right shrink-0">
                    <span className="text-[9px] text-carbon-900/50 block uppercase">
                      {item.metric.label}
                    </span>
                    <span className="text-xl sm:text-2xl font-serif font-bold text-carbon-900">
                      {item.metric.value}{' '}
                      <span className="text-chlorophyll-deep text-xs font-mono font-normal">
                        {item.metric.unit}
                      </span>
                    </span>
                  </div>
                </div>
              </DoubleBezelCard>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
